import Menu from "../Menu.js";
import ConfirmationArea from "./ConfirmationArea.js";

import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.AttachmentsEditArea");
log.setLevel(log.levels.WARN);

let AttachmentsEditArea = function () {
    var tools = global.tools;
    var scene = global.scene;

    let interaction_end = () => {
        Menu.close("attachemnts_edit_area");
    };

    var selected = null;

    Object.defineProperty(this, "selected", {
        set: () => {},
        get: () => selected
    });

    const unselect = () => {
        if (selected === null) {
            return;
        }
        scene.shadow.unaffect(selected.handle);
        selected = null;
    };

    const select = (node) => {
        if (selected !== null) {
            unselect();
        }
        selected = scene.objects.get_by_node("resources", node);
        scene.shadow.affect(selected.handle);
    };

    this.select = async (handle) => {
        if (global.scene.mode_switcher.mode !== "resources") {
            return;
        }
        await Menu.close("attachments_edit_area");
        select(handle);
        await Menu.display(["attachments_edit_area"]);
    };

    this.init = function () {
        tools = global.tools;
        scene = global.scene;

        Menu.create({
            name: "attachments_edit_area",
            icon: "resources",
            contents: ["#attachments_edit_options", "#attachments_edit_copy", "attachments_edit_delete"],
            open_handler: () => {
                global.scene.disable_draggable_tools();
            },
            close_handler: () => {
                unselect();
                if (global.scene.objects.layers.media.ids.length > 0) {
                    global.scene.enable_draggable_tools();
                }
            },
            close_timer: true
        });

        tools.register({
            name: "attachment_rename",
            icon: "rename",
            position: "#attachments_edit_options",
            handler: () => {
                let object = selected;
                global.resources
                    .request_name(object.handle, global.internationalization.text("media.Attachment-name"), global.internationalization.text("media.Attachment-name-shall-not-exceed-number-char", {number: "36"}))
                    .then((resource_name_text) => {
                        if (resource_name_text === null) {
                            return;
                        }
                        scene.objects.tx_update("resources", object);
                    });
            }
        });

        tools.register({
            name: "attachment_copy",
            icon: "duplicate",
            position: "#attachments_edit_copy",
            handler: () => {
                let old_object = selected;
                let new_object = scene.objects.duplicate("resources", old_object);
                let angle = Math.random() * 2 * Math.PI;
                new_object.move({
                    x: (50 * Math.cos(angle)) / scene.root_transform.k,
                    y: (50 * Math.sin(angle)) / scene.root_transform.k
                });
                let name = global.resources.name(new_object.handle);
                if (name !== undefined && name !== "") {
                    global.resources.name(new_object.handle, name + " " + global.internationalization.text("resource.copy"));
                }
                return global.resources
                    .request_name(new_object.handle, global.internationalization.text("media.Attachment-name"), global.internationalization.text("media.Attachment-name-shall-not-exceed-number-char", {number: "36"}))
                    .then((name) => {
                        if (name === null) {
                            scene.objects.layers["resources"].remove(new_object.id);
                            new_object = null;
                            return;
                        }
                        return scene.objects.publish("resources", new_object);
                    })
                    .then(() => {
                        if (new_object !== null) {
                            this.select(new_object.handle.node());
                        }
                    });
            }
        });

        tools.register({
            name: "attachment_download",
            icon: "export",
            position: "#attachments_edit_copy",
            handler: async () => {
                var media = await global.storage.selected_space.media_retrieve({
                    local_id: selected.node.attr("data-media")
                });
                if (media === undefined) {
                    return;
                }
                var {media_data, media_name} = media;
                let name = global.resources.name(selected.handle);
                if (name !== undefined && name !== "") {
                    media_name = name;
                }
                var object_url = window.URL.createObjectURL(media_data);
                // For other documents:
                // Create a link pointing to the ObjectURL containing the blob.
                var link = document.createElement("a");
                var media_extension = media.media_data.type.split("/")[1];
                link.href = object_url;
                link.download = `${media_name}.${media_extension}`;
                link.click();
                setTimeout(() => {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(object_url);
                }, 100);
            }
        });

        tools.register({
            name: "attachment_delete",
            icon: "suppp",
            position: "#attachments_edit_delete",
            handler: async () => {
                ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("media.Delete-attachment")
                }).then((confirmed) => {
                    if (!confirmed) {
                        return;
                    }
                    let object = selected;
                    
                    // first remove event player
                    let resource_id = object.handle.attr("id");
                    let floaters = document.getElementById("floater_" + resource_id);
                    if (floaters != null) {
                        floaters.parentNode.removeChild(floaters);
                    }

                    let media_id = object.node.attr("data-media");
                    log.debug("media_id ", media_id);
                    let media = global.storage.selected_space.media_retrieve({local_id: media_id});
                    log.debug("media retrieved ", media);
                    scene.objects.tx_delete("resources", object);

                    Menu.close("attachments_edit_area");
                });
            }
        });
    };
    window.addEventListener("f_mtac.init", () => {
        this.init();
    });

    this.interact = async function () {
        await Menu.close("attachments_edit_area");
        await Menu.display(["attachments_edit_area"]);
        return new Promise((resolve) => {
            $("body").on("click.attachments_edit_area", "#attachments_edit_area .btn-menu-close", () => {
                unselect();
                interaction_end();
                resolve(null);
            });
        });
    };
};
export default new AttachmentsEditArea();
